export default {
    // 流程递转
    toOtherPer(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/toOtherPer', params, response);
    },
    // 完成任务
    completeOrRefuse(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/completeOrRefuse', params, response);
    },
    // 流程运行中的任务信息
    findTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findTask', params, response);
    },
    // 查询运行中的流程信息
    findProIns(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findProIns', params, response);
    },
    // 查询历史流程信息
    findHisProcess(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findHisProcess', params, response);
    },
    // 查询历史任务信息
    findHisTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findHisTask', params, response);
    },
    // 流程拒绝
    reject(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/reject', params, response);
    },
    // 查询流程信息
    queryLeaveBillByCode(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/queryLeaveBillByCode', params, response);
    },
    queryTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findTemplate', params, response);
    }
};
